import React, { useEffect, useState } from "react";
import moment from "moment";
import { fetchJson, post } from "../../lib/Fetching";
import NotificationGroupForm from "./NotificationGroupForm";
import Button from "../Button";

export default function NewResultNotificationGroup({ company_id, clientView }) {
  const [show, setShow] = useState(false);
  const [group, setGroup] = useState({
    start_time_at: new Date(),
    company_branch_ids: [],
    notification_mechanism_ids: [1],
    test_query_parameter_id: null,
    person_ids: [],
    company_id,
  });

  const handleGroupSubmit = (group) =>
    post("/result_notifications/result_notification_groups", group)
      .then((json) => {
        if (json.errors) {
          alert(json.errors);
          return;
        }
        window.location = "/result_notifications/result_notification_groups/" + json.result.id;
      })
      .catch((error) => alert(error));

  const toggle = () => setShow(!show);

  return (
    <div>
      <Button
        icon="fa-plus"
        title={show ? "Cancel" : "Add Result Notification"}
        onClick={toggle}
      />
      {show && (
        <NotificationGroupForm
          newGroup={group}
          handleGroupSubmit={handleGroupSubmit}
          clientView={clientView}
        />
      )}
    </div>
  );
}
